/**
 * DataGridCellCheckbox — Toggle cell variant
 *
 * Toggles immediately on click (no separate "editing" state).
 * Follows the StorefrontToggleCell optimistic pattern.
 */

import { Loader2 } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import type { DataGridCellVariantProps } from './types';

export function DataGridCellCheckbox({
  value,
  onCommit,
  saveState,
}: DataGridCellVariantProps) {
  const checked = value === 1 || value === true || value === '1';

  const handleToggle = () => {
    onCommit(checked ? 0 : 1);
  };

  return (
    <div
      className="relative flex items-center justify-center w-full h-full min-h-[36px]"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.stopPropagation();
          e.preventDefault();
          handleToggle();
        } else if (e.key !== 'Tab' && e.key !== 'Escape') {
          e.stopPropagation();
        }
      }}
    >
      <Switch
        checked={checked}
        onCheckedChange={handleToggle}
        disabled={saveState.status === 'saving'}
        aria-label="Toggle value"
        className="h-[24px] w-[40px] [&>span]:h-[20px] [&>span]:w-[20px] [&>span]:data-[state=checked]:translate-x-[16px] [&>span]:data-[state=unchecked]:translate-x-[2px]"
      />
      {saveState.status === 'saving' && (
        <Loader2 className="absolute top-0.5 right-0.5 w-3 h-3 text-muted-foreground animate-spin" />
      )}
    </div>
  );
}
